import { DomainBase } from "./DomainBase";

 export class ReasonTypes extends DomainBase {
    // set the name of reasonType
    constructor() {
        super();
        this.name ='';
    }
}